import { Api } from '@coder-house/ch-coder-util'
import { IUser } from '../models/user.interface'
import { User } from '../models/user.model'

const { CH_API, VITE_CH_AUTH_SERVICE } = process.env

async function fetchUser() {
  const user = await Api.get<IUser>(`${VITE_CH_AUTH_SERVICE}/api/v1/auth/me`)
  return new User(user)
}

async function getUser() {
  const loggedUser = window.localStorage.getItem('user')
  if (loggedUser === null || loggedUser === '{}') {
    const user = await fetchUser()
    window.localStorage.setItem('user', JSON.stringify(user))
    return user
  }

  return JSON.parse(loggedUser)
}

async function getStreamToken(id: string) {
  const token = await Api.get<String>(`${CH_API}/platform/users/${id}/get-stream-token`)
  return token
}

async function getReferralCode() {
  const code = await Api.get(`${CH_API}/platform/referral/code`)
  return code
}

export { getUser, fetchUser, getStreamToken, getReferralCode }
